

import React from 'react';
import { FormattedMessage } from 'react-intl';
import {
    VerificationService,
    assertValidSegmentName,
    SegmentEnum,
    SubSegmentEnum,
} from '@sheerid/jslib';

interface Props {
    verificationService: VerificationService;
}

const UploadInfoComponent: React.SFC<Props> = ({ verificationService }) => {
    const { segment } = verificationService.verificationResponse;
    const { subSegment } = verificationService.verificationResponse;
    assertValidSegmentName(segment);

    switch (segment) {
        case SegmentEnum.EMPLOYMENT:
            return (
                <div>
                    <span>
                        <strong>
                            <FormattedMessage
                                id="step.docUpload.uploadInstructions"
                                defaultMessage="Upload an official document that shows:"
                            />
                        </strong>
                    </span>
                    <ul className="sid-upload-info-list">
                        <li className="sid-upload-info-list__li">
                            <FormattedMessage
                                id="step.docUpload.uploadInfo.employment.fullName"
                                defaultMessage="Your full name"
                            />
                        </li>
                        <li className="sid-upload-info-list__li">
                            <FormattedMessage
                                id="step.docUpload.uploadInfo.employment.company"
                                defaultMessage="Your company"
                            />
                        </li>
                        <li className="sid-upload-info-list__li">
                            <FormattedMessage
                                id="step.docUpload.uploadInfo.employment.currentAffiliation"
                                defaultMessage="Your current affiliation with that company"
                            />
                        </li>
                    </ul>
                </div>
            );
        default:
            return null;
    }
};

export { UploadInfoComponent };
